import type { AccordionProps } from '@movingimage-evp/mi-ui-component-library/types/components/accordion/accordion';
import type { ReactNode } from 'react';

import { Accordion, PlusIcon } from '@movingimage-evp/mi-ui-component-library';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  testId: string;
  visible?: boolean;
  buttonContent?: (isOpen: boolean) => ReactNode;
  children?: ReactNode;
} & Omit<AccordionProps, 'buttonContent'>;

export function MediaAccordion({ testId, visible, buttonContent, children, ...props }: Props) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(!visible);

  const _buttonContent =
    buttonContent?.(isOpen) ??
    (isOpen ? t('manager.webcastSetup.media.hideUpload') : t('manager.webcastSetup.media.uploadMedia'));

  if (visible)
    return (
      <Accordion
        data-testid={`${testId}-media-accordion`}
        buttonId={`${testId}-media-accordion-button`}
        compact
        isOpen={isOpen}
        onToggle={setIsOpen}
        buttonContent={
          <>
            <PlusIcon />
            {_buttonContent}
          </>
        }
        {...props}
      >
        {children}
      </Accordion>
    );

  return children;
}
